<iframe name="iframeAuthNet" [width]="frameSize.width" [height]="frameSize.height" frameborder="0"></iframe>

<form method="post" #form [action]="settings.actionUrl" target="iframeAuthNet">
  <input type="hidden" name="token" [value]="settings.token" />
  <input type="hidden" *ngIf="settings.paymentProfileId" name="PaymentProfileId" [value]="settings.paymentProfileId">
</form>